/** @format */

import React, { useState, useRef, useImperativeHandle, forwardRef, useEffect, useMemo } from 'react'
import { _$ } from 'kpc-react'
import BaseChart, { BaseChartMethod } from 'src/components/BaseChart'
import { useWindowSize, useDebounce } from 'react-use'
import NoData from 'src/components/NoData'
import { handleUnit, formatInt, tooltipFormatter, unitFormatBps, unitFormatbps } from 'src/utils'
import { minBy, maxBy } from 'lodash'
interface MonitorDashboardChartProps {
  chartData: any
  interval?: number
  height?: number
  checkedKeys?: string[]
  title?: string
  setCheckedKeys?: (keys: string[]) => void
}

export interface MonitorChartItemAppHandle {
  chartResize: () => void
  getOptions: () => any
}

const MonitorDashboardChar = React.memo(
  forwardRef<MonitorChartItemAppHandle, MonitorDashboardChartProps>(
    ({ chartData, interval, height, checkedKeys, setCheckedKeys, title }, ref) => {
      const chartRef = useRef<BaseChartMethod>()
      const { width: winWidth, height: winHeight } = useWindowSize()
      useDebounce(
        () => {
          chartRef?.current?.chartResize()
        },
        300,
        [winWidth, winHeight, height]
      )

      useImperativeHandle(ref, () => ({
        chartResize: () => chartRef?.current?.chartResize(),
        getOptions: () => chartRef?.current?.getOptions()
      }))

      useEffect(() => {
        if (chartData?.series?.length) {
          for (const item of chartData.series) {
            const result = item?.data?.some(item => typeof item === 'number')
            if (result) {
              break
            }
          }
        }
      }, [chartData?.series])

      const { unit } = useMemo(() => {
        if (chartData?.series?.length) {
          // 计算图表最大值最小值
          // const values: number[] = []
          // chartData?.series?.forEach(item => {
          //   const data = item.data.map(value => Number(value))
          //   values.push(...data)
          // })
          // const max = maxBy(values) as number
          // const min = minBy(values) as number
          // 计算单位
          const first = chartData.series[0].name.split('===')[1]
          if (unitFormatBps(first || '') || unitFormatbps(first || '')) {
            const bpsUnit = chartData.series.every(item => {
              const titleSplit = item?.name.split('===')[1]
              return titleSplit === first
            })
            return {
              unit: bpsUnit ? first : ''
              // yMax: max,
              // yMin: min
            }
          } else {
            return {
              unit: ''
              // yMax: max,
              // yMin: min
            }
          }
        } else {
          return {
            unit: ''
          }
        }
      }, [chartData])

      const onLegendChange = params => {
        const { selected } = params || {}
        if (setCheckedKeys && selected) {
          const keys = Object.keys(selected).filter(key => selected[key])
          setCheckedKeys(keys)
        }
      }

      const showKeys = useMemo(() => {
        const keys = {}
        if (chartData?.series?.length) {
          chartData?.series.forEach(({ name }) => {
            keys[name] = checkedKeys?.includes(name) ? true : false
          })
          return keys
        }
        return keys
      }, [checkedKeys, chartData?.series])

      return chartData ? (
        <BaseChart
          ref={chartRef}
          onLegendChange={onLegendChange}
          options={{
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: chartData?.xData || [],
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dashed'
                }
              }
            },
            series: chartData?.series || [],
            yAxis: {
              // min: formatInt(yMin, false),
              // max: formatInt(yMax),
              name:
                chartData?.interval || interval
                  ? `${_$('周期')}:${interval || chartData.interval}s`
                  : '',
              type: 'value',
              axisLine: {
                show: true
              },
              axisLabel: {
                showMinLabel: true,
                formatter: function (value, index) {
                  return handleUnit(value, unit, true)
                }
              }
            },
            tooltip: {
              trigger: 'axis',
              enterable: true,
              axisPointer: {
                animation: false
              },
              position: function (point, params, dom, rect, size) {
                const { contentSize, viewSize } = size
                let x, y
                // x
                if (point[0] > viewSize[0] - contentSize[0]) {
                  x = point[0] - contentSize[0]
                } else {
                  x = point[0]
                }
                // y
                if (point[1] > viewSize[1] - contentSize[1]) {
                  y = point[1] - contentSize[1]
                } else {
                  y = point[1]
                }
                x = x < 0 ? 0 : x
                return [x, y]
              },
              formatter: function (params) {
                return tooltipFormatter(params)
              }
            },
            legend: {
              type: 'scroll',
              right: '0',
              width: '80%',
              top: '-3px',
              selected: checkedKeys
                ? {
                    ...showKeys
                  }
                : {},
              formatter: name => {
                const nameSplit = name.split('===')
                return nameSplit[0]
              }
            },
            grid: {
              left: 35,
              right: 40,
              top: 35,
              bottom: 15,
              containLabel: true
            }
          }}
        />
      ) : (
        <NoData />
      )
    }
  )
)

export default MonitorDashboardChar
